// Shared catalog for Wellnet cities and services.
// Each city has: name, list of areas (neighbourhoods), and sample partner names
// split into "gym" and "recovery" categories.

export const CITIES = [
  {
    name: "New York, NY",
    areas: [
      "Midtown West & Hell's Kitchen", "Hudson Yards", "Chelsea", "Flatiron & NoMad",
      "Midtown East", "Upper East Side", "Tribeca & East Village",
      "Financial District", "Brooklyn", "Queens & Governors Island",
    ],
    partners: {
      gym: [
        "Mid City Gym — day $39, week $89",
        "Chelsea Piers Fitness — Hudson-side complex",
        "Brooklyn Athletic Club — day $35",
        "Life Time Sky — day $103",
      ],
      recovery: [
        "Othership Flatiron — 2-week intro $135",
        "Bathhouse — day from $39",
        "Russian & Turkish Baths — $60",
        "Remedy Place — guided ice bath",
      ],
    },
  },
  {
    name: "Los Angeles, CA",
    areas: [
      "West Hollywood", "Hollywood", "Venice", "West LA & Brentwood", "Santa Monica",
      "Culver City", "Downtown & Arts District", "Koreatown", "The Valley",
      "Pasadena", "Marina del Rey",
    ],
    partners: {
      gym: [
        "Easton Gym Co. — day $25, week $89",
        "Gold's Gym Venice — the original",
        "Cliffs of Id, Culver City — day $35",
        "Sender One LAX — day $34",
      ],
      recovery: [
        "SWTHZ Santa Monica — intro $35, single $80",
        "Wi Spa, Koreatown — $40 all-day",
        "Renew Performance, Pasadena — $40–60",
        "Pause Studio WeHo — contrast suites",
      ],
    },
  },
  {
    name: "Chicago, IL",
    areas: [
      "River North & Gold Coast", "The Loop & South Loop", "West Loop & Fulton Market",
      "Old Town & Lincoln Park", "Lakeview & Wrigleyville", "Bucktown & Wicker Park",
      "Logan Square", "Edgewater",
    ],
    partners: {
      gym: [
        "Quads Gym, Lakeview — day $20, week $75",
        "Fitness Formula Clubs — day $50, 10 clubs",
        "Bucktown Fitness Club — day $15",
        "MODE Gym, West Loop — day $40",
      ],
      recovery: [
        "Eastend Wellness Club — $45 sauna + plunge",
        "Chicago Bath House — $50 all-day banya",
        "EDGE Athlete Lounge — $45 recovery day pass",
        "SWTHZ Old Town — intro $35",
      ],
    },
  },
  {
    name: "Houston, TX",
    areas: [
      "River Oaks & Upper Kirby", "Uptown & Galleria", "The Heights",
      "Montrose & Midtown", "CityCentre & Memorial", "West U & Bellaire",
      "Sugar Land", "Northwest Houston",
    ],
    partners: {
      gym: [
        "Facet Seven Fitness — day $7, week $50",
        "Iconic Gym HTX — day $20, week $80",
        "Life Time CityCentre — day $75",
        "Momentum Memorial — day $29",
      ],
      recovery: [
        "Löyly Sauna Lounge — 7-day pass $49",
        "SWTHZ Autry Park — intro $35, single $70",
        "Calisthenics Club Fire & Ice — $45",
        "Altered States — plunge $29",
      ],
    },
  },
  {
    name: "Phoenix, AZ",
    areas: [
      "Biltmore & Camelback Corridor", "Arcadia & Uptown", "Paradise Valley",
      "North Scottsdale", "Downtown Phoenix", "Tempe & Mesa", "Chandler & Gilbert",
    ],
    partners: {
      gym: [
        "Phoenix Rock Gym, Tempe — day $20, 2 weeks $40",
        "Mountainside Fitness — free 5-day pass",
        "Life Time North Scottsdale — day $50",
        "FitLab Arizona — day $50",
      ],
      recovery: [
        "SWTHZ Paradise Valley — intro $25, single $60",
        "Optimyze — $69, first visit $35",
        "RejuvGen, Chandler — day $50, all therapies",
        "Cryo Tempe — 5 sessions $125",
      ],
    },
  },
  {
    name: "Philadelphia, PA",
    areas: [
      "Center City & Rittenhouse", "Northern Liberties & Fishtown", "Callowhill",
      "Old City", "South Philadelphia", "University City",
      "Manayunk & Roxborough", "Chestnut Hill",
    ],
    partners: {
      gym: [
        "PWRBLD Gym, Center City — free 7-day pass",
        "Movement Philadelphia — day $28",
        "The Sporting Club at The Bellevue — guest $40",
        "Philadelphia Rock Gyms — day $23",
      ],
      recovery: [
        "SWTHZ Northern Liberties — intro $35",
        "FORMATION — 90-min private sauna $85",
        "CURE de Repos — plunge $25",
        "Chung Dam Spa — day $33",
      ],
    },
  },
  {
    name: "San Antonio, TX",
    areas: [
      "Downtown & Southtown", "Pearl & Midtown", "Alamo Heights & The Quarry",
      "North Central (281)", "Stone Oak", "Northwest & Medical Center", "Boerne",
    ],
    partners: {
      gym: [
        "WarHouse Gym — day $30, week $70",
        "MBS Fitness, Southtown — day $15",
        "Life Time San Antonio 281 — day $50",
        "Armadillo Boulders — day $19",
      ],
      recovery: [
        "Transcend Health Spa — plunge $18, contrast $56",
        "Sweat Equity — 45-min contrast $45",
        "Evolve Human Labs — day pass $49",
        "Perspire Sauna Studio — $49",
      ],
    },
  },
  {
    name: "San Diego, CA",
    areas: [
      "Downtown & East Village", "Point Loma & Midway", "La Jolla", "Pacific Beach",
      "Hillcrest & Mission Hills", "North Park", "Carmel Valley & Del Mar",
      "North County",
    ],
    partners: {
      gym: [
        "Grinder Gym — day $20, week $60",
        "Ocean Pacific Gym — day $35, week $130",
        "The Anvil Gym — day $25, 5-day $100",
        "Fit Athletic Club — day $30 ($20 hotel guests)",
      ],
      recovery: [
        "Soul Plunge, La Jolla — 2 weeks unlimited $69",
        "r3 recover — guided contrast hour $69",
        "Conscious Body Recovery — $50, first $29",
        "SWTHZ One Paseo — intro $35",
      ],
    },
  },
  {
    name: "Dallas, TX",
    areas: [
      "Uptown & West Village", "Katy Trail & Knox", "Highland Park & Oak Lawn",
      "Deep Ellum", "Bishop Arts & Design District", "Mockingbird & East Dallas",
      "Preston Hollow", "Plano & Frisco",
    ],
    partners: {
      gym: [
        "Recess Fitness Club — day $50, week $75",
        "Svelte Performance — day $25, 4-day traveler $50",
        "PARADIGM Gym — day $30",
        "Trophy Fitness — free 7-day trial",
      ],
      recovery: [
        "SWTHZ West Village — intro $25, plunge $20",
        "My Sauna House — sauna + plunge $59",
        "Alive and Well — contrast $35–59",
        "WorldSprings — day from $58",
      ],
    },
  },
  {
    name: "Austin, TX",
    areas: [
      "Downtown & Old West Austin", "South Congress & South Austin", "East Austin",
      "Central & Hyde Park", "North & Arboretum", "Southeast",
      "Westlake & Bee Cave", "Round Rock",
    ],
    partners: {
      gym: [
        "Big Tex Gym — day $10, week $35",
        "Castle Hill Fitness — visit $30, week $70",
        "Austin Bouldering Project — day $25",
        "Los Campeones — day $19, week $29",
      ],
      recovery: [
        "CØNTRAST ATX — communal $29, private $49",
        "Kuya Wellness — day pass $65",
        "Generator Athlete Lab — recovery day $75",
        "The Ocean Lab — unlimited trial week $80",
      ],
    },
  },
  {
    name: "Miami, FL",
    areas: [
      "Brickell & Downtown", "Midtown & Design District", "South Beach",
      "North Beach", "Coral Gables", "South Miami", "Little Havana",
      "Doral & Aventura",
    ],
    partners: {
      gym: [
        "Gallo 8 Gym — day $5, week $14",
        "Anatomy Midtown — day $100, week $250",
        "Beach Body Health Club — day $25",
        "Rock Fitness Doral — day $40, 7-day $99",
      ],
      recovery: [
        "ELIXR — cold plunge $25, 10 for $200",
        "The Plunge and Sauna Method — $45",
        "Prestige Miami — plunge $30, +sauna $45",
        "SWTHZ Aventura — intro $35, single $60",
      ],
    },
  },
  {
    name: "Atlanta, GA",
    areas: [
      "Buckhead", "Midtown & West Midtown", "Old Fourth Ward & Inman Park",
      "Virginia-Highland", "Sandy Springs & Dunwoody", "Chamblee & Brookhaven",
      "Decatur", "Alpharetta",
    ],
    partners: {
      gym: [
        "Gravity Fitness — day $20, 7-day $35",
        "The Forum Athletic Club — $14/week, no contract",
        "Life Time Sandy Springs — day $60",
        "Urban Body Fitness — 7-day trial $25",
      ],
      recovery: [
        "SWTHZ Midtown — intro $25, single $60",
        "Do Not Disturb, Ponce City — $60 per visit",
        "Wellhaus Club — Fire & Ice $50–70",
        "RestFuel Wellness — drop-in $50",
      ],
    },
  },
  {
    name: "Boston, MA",
    areas: [
      "Back Bay & Downtown", "Seaport", "South Boston", "South End & Fenway",
      "Cambridge & Somerville", "Allston & Charlestown", "Jamaica Plain",
      "Newton & Dedham",
    ],
    partners: {
      gym: [
        "Mike's Fitness JP — all-access day $15",
        "BU FitRec — day $15, pools and track",
        "Rock Spot South Boston — day $35 with gear",
        "Boston Bouldering Project — day $30",
      ],
      recovery: [
        "B/SPOKE REVIVE — contrast $45, first $25",
        "IV League Fire & Ice — intro $39, single $69",
        "Moki Sauna, Allston — social session $59",
        "Kelo Spa — 3-hour banya $69",
      ],
    },
  },
  {
    name: "San Francisco, CA",
    areas: [
      "Union Square & FiDi", "SoMa", "Nob Hill & Japantown", "Marina & Cow Hollow",
      "Mission & Castro", "Dogpatch", "Hayes Valley", "Sunset & Richmond", "Presidio",
    ],
    partners: {
      gym: [
        "Sunset Gym — day $20, week $50",
        "FITNESS SF — day $35, 7-day $129, all clubs",
        "Movement San Francisco — day $33",
        "Mission Cliffs — day $30–35, sauna included",
      ],
      recovery: [
        "Dogpatch Paddle Sauna — sauna $25/hr, +plunge $35",
        "Kabuki Springs — 2.5-hour bath $49",
        "Onsen SF — communal bath $50",
        "Reboot Float & Cryo — contrast $70",
      ],
    },
  },
  {
    name: "Seattle, WA",
    areas: [
      "Downtown & Waterfront", "South Lake Union", "Capitol Hill",
      "Ballard & Fremont", "Wallingford & Greenwood", "West Seattle",
      "Eastlake & Lake Union", "Bellevue & Kirkland",
    ],
    partners: {
      gym: [
        "PNW Fitness, Capitol Hill — day $20, week $50",
        "Ballard Health Club — day $25, week $65",
        "Fremont Health Club — day $17, week $60",
        "Vertical World — day $27",
      ],
      recovery: [
        "Tuli Lodge, Pier 62 — sauna + plunge $27/hr",
        "Bywater Sauna, Alki Beach — $35–40",
        "Banya 5 — 2-hour banya $70",
        "FLOAT Seattle Fire & Ice — $79",
      ],
    },
  },
  {
    name: "Denver, CO",
    areas: [
      "Downtown & LoDo", "RiNo", "LoHi & Highlands", "Capitol Hill",
      "South Broadway & Platt Park", "Cherry Creek", "Central Park", "Boulder",
    ],
    partners: {
      gym: [
        "Denver Gym and Fitness — day $15, week $42",
        "Mountains' Edge, Boulder — day $15, week $40",
        "The Spot Climbing — day $28",
        "Movement RiNo — day $29",
      ],
      recovery: [
        "Denver Sports Recovery — day $35, week $125",
        "Rök Spas, LoDo — 2-hour contrast $42",
        "The Cove — sauna + plunge from $24",
        "Garden Sauna — $33, first visit $12",
      ],
    },
  },
  {
    name: "Washington, DC",
    areas: [
      "Downtown & Golden Triangle", "Mount Vernon Triangle & Shaw", "U Street",
      "Capitol Hill & Navy Yard", "Georgetown", "Northwest DC",
    ],
    partners: {
      gym: [
        "Urban Athletic Club, Shaw — day $25, week $80",
        "VIDA Fitness — 3-day guest pass $45",
        "CrossFit DC — 7-day open gym $99",
        "Equinox Sports Club — flagship club",
      ],
      recovery: [
        "Capital Cryo — cryo $65, intro 3 for $99",
        "Georgetown Sun Cryo — whole-body $55",
        "DistrictCryo, Shaw — recovery lab",
        "Pure Sweat Georgetown — private sauna suites",
      ],
    },
  },
  {
    name: "Nashville, TN",
    areas: [
      "The Gulch & Downtown", "Germantown", "Midtown & Music Row",
      "East Nashville", "Green Hills", "Wedgewood-Houston",
      "West Nashville", "Franklin & Brentwood",
    ],
    partners: {
      gym: [
        "Centennial Sportsplex — day $10, pools and sauna",
        "QNTM Fit Life, The Gulch — day $30, week $80",
        "The Crag — day $18",
        "The Climb Gyms — 1 month, no commitment $135",
      ],
      recovery: [
        "Framework — $35 weekday, intro week $79",
        "Contrast Club, Green Hills — 60-min $35",
        "SWTHZ Germantown — intro $40, single $70",
        "Pure Sweat, The Gulch — private suites",
      ],
    },
  },
  {
    name: "Las Vegas, NV",
    areas: [
      "The Strip & South", "Summerlin & West", "Downtown & Arts District",
      "Southwest", "Henderson & Green Valley", "North Las Vegas & Centennial",
    ],
    partners: {
      gym: [
        "Red Rock Climbing Center — day $20, month $78",
        "Dragon's Lair Gym — day $30, week $99",
        "Fit Club Las Vegas — day $30, 3-day $75",
        "Camp Rhino — day $25, week $75",
      ],
      recovery: [
        "Sweat Equity Studios — plunge + sauna $25, day $45",
        "Cold Summer — plunge + sauna $45",
        "Elevated Cryotherapy — cryo $40, first $25",
        "IMR Float Fire & Ice — $90, first $65",
      ],
    },
  },
  {
    name: "Charlotte, NC",
    areas: [
      "Uptown & Dilworth", "South End & LoSo", "Wilmore", "NoDa",
      "SouthPark & Cotswold", "Ballantyne & Pineville", "Steele Creek", "Matthews",
    ],
    partners: {
      gym: [
        "Dowd YMCA, Uptown — day $20, week $50",
        "Charlotte Athletic Club — day $24, free for Omni guests",
        "The Fitness Factory, NoDa — day $20",
        "CORE24 — day $33, outdoor sauna + plunge",
      ],
      recovery: [
        "Arrichion Recovery — plunge $10, recovery $29",
        "TruMotion Therapy — contrast $55, intro $35",
        "Sauna Culture — 90-min day pass $40–50",
        "Sunday Hotsprings — 2-hour bathhouse $77",
      ],
    },
  },
];

// City rates for gym [dayLo, dayHi, weekLo (or null), weekHi (or null)] and cold [singleLo, singleHi, weekPass (or null)]
export const CITY_RATES = {
  "New York, NY":       { gym: [35,103,89,null],  cold: [39,99,135] },
  "Los Angeles, CA":    { gym: [10,50,89,null],   cold: [35,80,null] },
  "Chicago, IL":        { gym: [15,50,75,null],   cold: [45,80,null] },
  "Houston, TX":        { gym: [7,75,50,80],      cold: [25,70,49] },
  "Phoenix, AZ":        { gym: [20,50,40,null],   cold: [25,69,null] },
  "Philadelphia, PA":   { gym: [23,50,35,null],   cold: [25,85,null] },
  "San Antonio, TX":    { gym: [15,50,70,75],     cold: [18,56,null] },
  "San Diego, CA":      { gym: [20,35,55,130],    cold: [39,69,69] },
  "Dallas, TX":         { gym: [23,50,75,null],   cold: [20,65,null] },
  "Austin, TX":         { gym: [10,30,35,70],     cold: [29,75,80] },
  "Miami, FL":          { gym: [5,100,14,250],    cold: [25,69,null] },
  "Atlanta, GA":        { gym: [20,60,35,null],   cold: [25,70,null] },
  "Boston, MA":         { gym: [15,35,null,null], cold: [25,80,null] },
  "San Francisco, CA":  { gym: [20,35,50,129],    cold: [25,70,null] },
  "Seattle, WA":        { gym: [7,27,50,65],      cold: [27,79,null] },
  "Denver, CO":         { gym: [15,29,40,42],     cold: [24,80,125] },
  "Washington, DC":     { gym: [25,45,80,99],     cold: [45,65,null] },
  "Nashville, TN":      { gym: [10,30,80,null],   cold: [18,70,79] },
  "Las Vegas, NV":      { gym: [20,30,50,99],     cold: [25,90,null] },
  "Charlotte, NC":      { gym: [20,33,50,null],   cold: [10,77,null] },
};

// Per-hour rates for trainer (session length adjusts) and massage (session length adjusts).
// Values are [lo, hi] for a 60-minute session; 90/120min scaled by 1.5×/2×.
export const TRAINER_RATES_60 = {
  "New York, NY": [140,220], "Los Angeles, CA": [125,200], "Chicago, IL": [100,170],
  "Houston, TX": [90,160], "Phoenix, AZ": [85,150], "Philadelphia, PA": [95,160],
  "San Antonio, TX": [80,140], "San Diego, CA": [110,180], "Dallas, TX": [95,165],
  "Austin, TX": [95,160], "Miami, FL": [110,190], "Atlanta, GA": [90,155],
  "Boston, MA": [110,180], "San Francisco, CA": [130,210], "Seattle, WA": [110,180],
  "Denver, CO": [95,165], "Washington, DC": [115,190], "Nashville, TN": [95,165],
  "Las Vegas, NV": [100,175], "Charlotte, NC": [85,150],
};
export const MASSAGE_RATES_60 = {
  "New York, NY": [165,260], "Los Angeles, CA": [150,240], "Chicago, IL": [125,200],
  "Houston, TX": [110,180], "Phoenix, AZ": [105,175], "Philadelphia, PA": [115,190],
  "San Antonio, TX": [100,165], "San Diego, CA": [130,210], "Dallas, TX": [115,190],
  "Austin, TX": [115,185], "Miami, FL": [130,215], "Atlanta, GA": [110,180],
  "Boston, MA": [130,210], "San Francisco, CA": [150,240], "Seattle, WA": [130,210],
  "Denver, CO": [115,190], "Washington, DC": [135,220], "Nashville, TN": [115,190],
  "Las Vegas, NV": [120,200], "Charlotte, NC": [105,175],
};

// Which services show indicative rates in the summary rail
export const PRICED_SERVICE_IDS = new Set(["gym", "cold", "trainer", "massage"]);

export const CITY_NAMES = CITIES.map((c) => c.name);

// Services matching the standalone design — id + display name + description +
// units (for the "package/length/type" dropdown) + labels.
export const SERVICES = [
  {
    id: "gym", name: "Gym access",
    desc: "Day, week or month access at a vetted partner club",
    units: [
      { v: "day", l: "Day pass" },
      { v: "3day", l: "3-day pass" },
      { v: "week", l: "1 week" },
      { v: "2week", l: "2 weeks" },
      { v: "month", l: "1 month" },
    ],
    unitLabel: "Pass", qtyLabel: "People",
  },
  {
    id: "cold", name: "Cold therapy & contrast",
    desc: "Cold plunge, contrast suite, sauna or whole-body cryo",
    units: [
      { v: "single", l: "Single session" },
      { v: "3pack", l: "3 sessions" },
      { v: "5pack", l: "5 sessions" },
      { v: "week", l: "Unlimited week" },
    ],
    unitLabel: "Package", qtyLabel: "Sessions",
  },
  {
    id: "trainer", name: "Personal trainer",
    desc: "1:1 coaching at your gym, hotel or residence",
    units: [
      { v: "60", l: "60 minutes" },
      { v: "90", l: "90 minutes" },
    ],
    unitLabel: "Session length", qtyLabel: "Sessions",
  },
  {
    id: "massage", name: "Massage therapy",
    desc: "Sports, deep tissue or recovery — in studio or in room",
    units: [
      { v: "60", l: "60 minutes" },
      { v: "90", l: "90 minutes" },
      { v: "120", l: "120 minutes" },
    ],
    unitLabel: "Session length", qtyLabel: "Sessions",
  },
  {
    id: "chiro", name: "Chiropractic",
    desc: "Adjustment and assessment with a sports-focused practitioner",
    units: [
      { v: "adjust", l: "Adjustment" },
      { v: "assess", l: "Full assessment + adjustment" },
    ],
    unitLabel: "Visit type", qtyLabel: "Visits",
  },
  {
    id: "lymph", name: "Lymphatic drainage",
    desc: "Manual lymphatic drainage or compression therapy",
    units: [
      { v: "manual", l: "Manual drainage" },
      { v: "compression", l: "Compression therapy" },
    ],
    unitLabel: "Method", qtyLabel: "Sessions",
  },
  {
    id: "iv", name: "IV therapy",
    desc: "Hydration, recovery or vitamin infusion, clinician-administered",
    units: [
      { v: "hydration", l: "Hydration" },
      { v: "recovery", l: "Recovery / performance" },
      { v: "immune", l: "Immune support" },
      { v: "nad", l: "NAD+" },
    ],
    unitLabel: "Drip", qtyLabel: "Infusions",
  },
];

export const SERVICE_NAMES = SERVICES.map((s) => s.name);

export const DURATIONS = [
  "1 day", "Weekend", "3–5 days", "1 week", "2 weeks", "1 month", "Ongoing / relocating",
];

export const TIMES = [
  "Early morning", "Midday", "Evening", "Flexible", "Same-day arrival", "Weekends only",
];
